import { Component, ElementRef, EventEmitter, inject, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, FormsModule, NonNullableFormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzInputDirective, NzInputGroupComponent, NzInputGroupWhitSuffixOrPrefixDirective } from 'ng-zorro-antd/input';
import { NzMessageModule, NzMessageService } from 'ng-zorro-antd/message';
import { NZ_MODAL_DATA, NzModalFooterDirective, NzModalRef, NzModalTitleDirective } from 'ng-zorro-antd/modal';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzTableCellDirective, NzTableComponent, NzTbodyComponent, NzTheadComponent, NzThMeasureDirective, NzTrDirective } from 'ng-zorro-antd/table';
import { Subject } from 'rxjs';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
import { IconDefinition } from '@ant-design/icons-angular';
import { PlusCircleFill } from '@ant-design/icons-angular/icons';
import { NzFormControlComponent, NzFormDirective, NzFormItemComponent, NzFormModule } from 'ng-zorro-antd/form';
import { RawMaterialDto } from 'src/app/shared/dto/rawMaterial.dto';
import { ProductionOrderProcessesService } from 'src/app/private/services/production-order-processes.service';

const icons: IconDefinition[] = [
    PlusCircleFill
];

@Component({
    selector: 'app-modal-raw-material-edition',
    templateUrl: './modal-raw-material-edition.component.html',
    styleUrls: ['./modal-raw-material-edition.component.scss'],
    standalone: true,
    imports: [
        NzTableComponent,
        NzTheadComponent,
        NzTrDirective,
        NzModalTitleDirective,
        NzTableCellDirective,
        NzThMeasureDirective,
        NzTbodyComponent,
        ReactiveFormsModule,
        FormsModule,
        NzModalFooterDirective,
        NzMessageModule,
        NzSelectModule,
        NzInputDirective,
        NzInputGroupComponent,
        NzIconModule,
        NzToolTipModule,
        NzInputGroupWhitSuffixOrPrefixDirective,
        NzEmptyModule,
        LoaderComponent,
        NzButtonModule,
        NzFormDirective,
        NzFormItemComponent,
        NzFormControlComponent,
        NzFormModule
    ],
})
export class ModalRawMaterialEditionComponent {
    @Output() emitService = new EventEmitter();
    @ViewChild('modalContent') private readonly _modalContent!: ElementRef;

    isLoading: boolean = true;
    tableHeight!: number;
    rawMaterial!: RawMaterialDto;

    validateForm: FormGroup<{
        articleName: FormControl<string>;
        batchNumber: FormControl<string>;
        quantity: FormControl<number>
    }>;

    readonly nzModalData = inject(NZ_MODAL_DATA);
    readonly fb = inject(NonNullableFormBuilder);
    readonly message = inject(NzMessageService);

    private readonly unsubscribe$ = new Subject();

    private readonly modalRef = inject(NzModalRef);
    private readonly productionOrderProcessesService = inject(ProductionOrderProcessesService);

    constructor() {
        this.rawMaterial = this.nzModalData.rawMaterial;
        const quantity: number = this.rawMaterial.usedPackaging ? this.rawMaterial.usedPackaging.quantity! : this.rawMaterial.rawQuantity;

        this.validateForm = this.fb.group({
            articleName: [''],
            batchNumber: [''],
            quantity: [quantity, [Validators.required, Validators.min(1)]]
        });

        this.isLoading = false;
    }

    handleSave() {
        try {

            if (!this.validateForm.valid) {
                this.message.error(`Porfavor, rellene correctamente los campos obligatorios`);
                return;
            }

            this.rawMaterial.rawQuantity = this.validateForm.controls.quantity.value;

            this.emitService.next(this.rawMaterial);

            this.modalRef.close();
        } catch (e: unknown) {
            if (e instanceof Error) {
                this.message.error(e.message);
            }
        }
    }

    async handleDelete() {
        await this.productionOrderProcessesService.deleteUsedRawMaterialById(this.rawMaterial.id!);

        this.message.success(`Materia prima eliminada correctamente`);

        this.emitService.next(null);

        this.modalRef.close();
    }

    handleCancel() {
        this.modalRef.close();
    }
}
